import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import ATBHero from "./ATBHero";
import Maximize from "./Maximize";
import WhatIsArbitrageT from "./WhatIsArbitrageT";
import Automation from "./Automation";
import Backtesting from "./Backtesting";
import MultiIntegration from "./MultiIntegration";
import SpatialArbitrage from "./SpatialArbitrage";
import TriangularArbitrage from "./TriangularArbitrage";
import FasterTradeExecution from "./FasterTradeExecution";
import WhyChoose from "../../Wallet/NFT Wallet/WhyChoose";

function ArbitrageTradingBots() {
  return (
    <div>
      <Header />
      <ATBHero />
      <Maximize />
      <WhatIsArbitrageT />
      <Automation />
      <Backtesting />
      <SpatialArbitrage />
      <TriangularArbitrage />
      {/* <FasterTradeExecution /> */}
      {/* <MultiIntegration /> */}
      <WhyChoose />
      <Footer />
    </div>
  );
}

export default ArbitrageTradingBots;
